import ApiUrlConstant from '../../../../Shared/Utils/UrlConstants';
import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';
import { store } from '../../../../Redux/Store';
import { clearOrders, setOrders } from '../../../../Shared/Slice/OrdersSlice';

const Service = {
  getPatientList: (params = {}) => {
    // params = { page: 2 } etc.
    return axiosInstance.get(ApiUrlConstant.getPatientList(), {
      params, // ✅ this adds ?page=2 automatically
      loaderKey: 'get-patient', // optional custom config
    });
  },
  // `fresh` skips the cached list, e.g. right after issuing a replacement kit.
  getOrderList: (id, { fresh = false } = {}) => {
    if (fresh) store.dispatch(clearOrders(id));
    const state = store.getState();
    const cached = state?.orders?.byId?.[id]?.data;
    if (cached) {
      return Promise.resolve({ data: cached });
    }
    return axiosInstance.get(ApiUrlConstant.getOrderList(id), { loaderKey: 'get-orderList' }).then((res) => {
      try {
        const orders = res?.data || [];
        store.dispatch(setOrders({ id, orders }));
      } catch (e) {
        // ignore cache write errors
      }
      return res;
    });
  },
  // Supplement (OK Capsule) orders live in the medication app, not in the
  // Shopify order list — fetched separately and merged on the page. Not cached:
  // fulfillment status changes via OK Capsule webhooks, so admins need it fresh.
  getSupplementOrders: (id) => {
    return axiosInstance.get(ApiUrlConstant.getPatientSupplementOrders(id), { loaderKey: 'get-supplementOrders' });
  },
  // Replacement kits ("Re-order Kit") for one order: GET lists them plus the
  // kits/reasons the modal offers, POST issues one, retry re-places a kit a lab
  // rejected.
  getOrderReplacements: (orderId) => axiosInstance.get(ApiUrlConstant.orderReplacements(orderId), { loaderKey: 'get-orderReplacements' }),
  createOrderReplacement: (orderId, body) =>
    axiosInstance.post(ApiUrlConstant.orderReplacements(orderId), body, { loaderKey: 'create-orderReplacement' }),
  retryOrderReplacement: (replacementId) =>
    axiosInstance.post(ApiUrlConstant.retryOrderReplacement(replacementId), {}, { loaderKey: 'retry-orderReplacement' }),
};

export default Service;
